// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import checkoutSharedStyles from "@awc/App/SharedStyles/CheckoutSharedStyles";
import { orderTotalDisplaySharedStyles } from "@awc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@awc/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const label: TypographyPresentationProps = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    weight: fontConfig.weight.regular,
    color: "primary.main",
    css: css`
        letter-spacing: 0;
    `,
};
const value: TypographyPresentationProps = {
    ...label,
    css: css`
        margin-left: auto;
    `,
}
const totalLabel: TypographyPresentationProps = {
    size: fontConfig.fontSize.link,
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
    color: "primary.main",
    css: css`
        letter-spacing: 0;
    `,
};
const totalValue: TypographyPresentationProps = {
    ...totalLabel,
    css: css`
        margin-left: auto;
    `,
};

cartTotalStyles.title = {
    ...checkoutSharedStyles.orderSummaryTitle,
    forwardAs: "h2"
};
cartTotalStyles.cartTotal = {
    container: {
        css: css`
            border: 0;
            padding: 0;
        `,
    },
    promotionLabel: {
        ...label,
    },
    discountsLabel: {
        ...label,
    },
    shippingAndHandlingLabel: {
        ...label,
    },
    otherChargesLabel: {
        ...label,
    },
    taxLabel: {
        ...label,
    },
    totalLabel: {
        ...totalLabel,
    },
    labelGridItem: {
        ...orderTotalDisplaySharedStyles.labelGridItem,
    },
    subtotalLabel: {
        ...label,
    },
    subtotalValue: {
        ...value,
    },
    totalValue: {
        ...totalValue,
    },
    valueGridItem: {
        ...orderTotalDisplaySharedStyles.valueGridItem,
    },
    promotionValue: {
        ...value,
    },
    shippingAndHandlingValue: {
        ...value,
    },
    taxValue: {
        ...value,
    },
    discountsValue: {
        ...value,
    },
    orderFeeLabel: {
        ...label,
    },
    orderFeeValue: {
        ...value,
    },
};
cartTotalStyles.cartTotalInfoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        align-items: center;
        ${checkoutSharedStyles.sectionInnerContainer?.css}
    `,
};
cartTotalStyles.buttonsGridItem = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
    `,
}
cartTotalStyles.placeOrderButton = {
    variant: "primary",
    sizeVariant: "large",
    css: css`
        min-width: max(249px, 60%);
    `,
};
cartTotalStyles.submitForApprovalButton = {
    css: css`
        min-width: max(249px, 60%);
    `,
};
cartTotalStyles.cartTotalGridItem = {
    css: css`
        width: 100%;
    `,
}